import {CONFIG} from './config';

export const backendUrl: string = CONFIG.API_URL;
// 'https://stoplight.io/mocks/token-lab/token/674329350'; // for mock API
// ('http://localhost:7121'); // for local development
// 'https://dashout-backend-dev.azurewebsites.net'; //for development
//'https://dashout-backend-prod.azurewebsites.net'; //for prod
//

export const signInEndpoint = '/api/v1/auth/signin';
export const signUpEndpoint = '/api/v1/auth/signup';
export const refreshTokenEndpoint = '/api/v1/auth/refresh';

export const getEventListEndpoint = (organzierId: string) =>
  `/api/v1/organizer/${organzierId}/getEvents`;
export const getPlaceListEndpoint = (organizerId: string) =>
  `/api/v1/organizer/${organizerId}/getPlaces`;
export const getEventDetailsEndpoint = (eventId: string, userId: string) =>
  `/api/v1/events/eventDetails/${eventId}/${userId}`;
export const getOrganizerEventDetailsEndpoint = (
  organizerId: string,
  eventId: string,
) => `/api/v1/organizer/${organizerId}/event/${eventId}`;
export const insertEventEndpoint = (organizerId: string) =>
  `/api/v1/organizer/${organizerId}/event`;
export const insertBulkEventEndpoint = (organizerId: string) =>
  `/api/v1/organizer/${organizerId}/event/bulk`;
export const updateEventEndpoint = (organizerId: string, eventId: string) =>
  `/api/v1/organizer/${organizerId}/event/${eventId}`;
export const updateBulkEventEndpoint = (organizerId: string) =>
  `/api/v1/organizer/${organizerId}/event/bulk`;
export const organizerSearchEndpoint = (organizerName: string) =>
  `/api/v1/organizer/search/${encodeURIComponent(organizerName)}`;
export const pendingClaimsEndpoint = '/api/v1/organizer/pendingClaims';
export const pendingBusinessesEndpoint = '/api/v1/organizer/pendingBusinesses';
export const updateClaimStatusEndpoint = (placeId: string, status: number) =>
  `/api/v1/organizer/updateClaimPlaceStatus/${placeId}/${status}`;
export const updateAccountStatusEndpoint = (
  organizerId: string,
  status: number,
) => `/api/v1/organizer/updateAccountStatus/${organizerId}/${status}`;

export const deleteEventEndpoint = (organizerId: string, eventId: string) =>
  `/api/v1/organizer/${organizerId}/event/${eventId}`;

export const organizerByIdEndpoint = (organizerId: string) =>
  `/api/v1/organizer/${organizerId}`;

export const placeDetailsForEditEndpoint = (placeId: string) =>
  `/api/v1/place/organizerPlaceDetails/${placeId}`;
export const insertPlaceEndpoint = (organizerId: string) =>
  `/api/v1/place/${organizerId}/place`;
export const updatePlaceEndpoint = (placeId: string) =>
  `/api/v1/place/updatePlace/${placeId}`;
export const deletePlaceEndpoint = (placeId: string) =>
  `/api/v1/place/deletePlace/${placeId}`;

export const adminActivitiesEndpoint = '/api/v1/search/admin/activities';
export const adminUsersEndpoint = '/api/v1/admin/users';
export const adminUserStatsEndpoint = '/api/v1/admin/users/stats';
export const adminUserEndpoint = (id: string) => `/api/v1/admin/users/${id}`;

export const categoriesWithTagsEndpoint: string = '/api/v1/categories/tags';
export const categories: string = '/api/v1/categories';

export const locationEndpoint: string = '/api/v1/location';

export const cdnStringEndpoint: string = '/api/v1/config/cdn/sas';
export const adminUserSettingsEndpoint = (id: string) =>
  `/api/v1/admin/users/${id}/settings`;
export const adminSupportConversationsEndpoint =
  '/api/v1/admin/support/conversations';
export const adminSupportMessagesEndpoint = (conversationId: string) =>
  `/api/v1/admin/support/conversations/${conversationId}/messages`;
export const adminSupportReadEndpoint = (conversationId: string) =>
  `/api/v1/admin/support/conversations/${conversationId}/read`;
export const adminSupportResolveEndpoint = (conversationId: string) =>
  `/api/v1/admin/support/conversations/${conversationId}/resolve`;
export const adminTagsEndpoint = '/api/v1/admin/tags';
export const adminTagEndpoint = (code: number) => `/api/v1/admin/tags/${code}`;
export const adminCitiesEndpoint = '/api/v1/admin/locations';
export const adminCityEndpoint = (code: number) =>
  `/api/v1/admin/locations/${code}`;
export const adminRecommendationRebuildEndpoint =
  '/api/v1/admin/recommendations/rebuild';
export const adminTokenRulesEndpoint = '/api/v1/admin/tokens/rules';
export const adminTokenRuleEndpoint = (kind: string) =>
  `/api/v1/admin/tokens/rules/${kind}`;
export const adminTokenSettingsEndpoint = '/api/v1/admin/tokens/settings';
export const adminTokenChangesEndpoint = '/api/v1/admin/tokens/changes';
export const adminUserTokensEndpoint = (id: string) =>
  `/api/v1/admin/tokens/users/${id}`;
export const adminUserTokensAdjustEndpoint = (id: string) =>
  `/api/v1/admin/tokens/users/${id}/adjust`;
export const adminUserTokensTrustEndpoint = (id: string) =>
  `/api/v1/admin/tokens/users/${id}/trust`;
export const adminTokenAbuseEndpoint = '/api/v1/admin/tokens/abuse';
export const adminTokenAbuseResolveEndpoint = (id: number) =>
  `/api/v1/admin/tokens/abuse/${id}/resolve`;
export const adminChallengesEndpoint = '/api/v1/admin/challenges';
export const adminChallengeEndpoint = (id: string) =>
  `/api/v1/admin/challenges/${id}`;
export const adminChallengePublishEndpoint = (id: string) =>
  `/api/v1/admin/challenges/${id}/publish`;
export const adminChallengeEndEndpoint = (id: string) =>
  `/api/v1/admin/challenges/${id}/end`;
export const adminChallengeTemplatesEndpoint =
  '/api/v1/admin/challenges/templates';
export const adminChallengeTemplateEndpoint = (id: number) =>
  `/api/v1/admin/challenges/templates/${id}`;
export const staticPreferencesEndpoint = '/api/v1/preference/static';
